/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Item, ItemActions, ItemContent, ItemMedia, ItemTitle } from "@farmlands/shadcn-ui";
import { ChevronRight, LucideIcon } from "lucide-react";
import { ReactNode } from "react";

export interface QuickLinkTileProps {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
  badge?: ReactNode;
  testId: string;
}

export const QuickLinkTile = ({
  icon: Icon,
  label,
  onClick,
  badge,
  testId,
}: QuickLinkTileProps) => (
  <Item
    asChild
    className={`
      rounded-md p-2 transition-colors
      hover:bg-grazing-green-50!
      [&:not(:disabled)]:active:bg-grazing-green-100!
      [[data-slot=item-group]_&]:rounded-md!
    `}
  >
    <button type="button" onClick={onClick} className="w-full text-left" data-testid={testId}>
      <ItemMedia>
        <Icon aria-hidden />
      </ItemMedia>
      <ItemContent>
        <ItemTitle>{label}</ItemTitle>
      </ItemContent>
      <ItemActions>
        {badge}
        <ChevronRight aria-hidden />
      </ItemActions>
    </button>
  </Item>
);
